/* eslint-disable no-useless-catch */
/* eslint-disable unused-imports/no-unused-vars */
import {
  ORDERS_URL,
} from "constants/url.constant";

import { API } from "api";
import { setError } from "../Indicator";

export const SET_PRODUCT_SKU_LIST = "SET_PRODUCT_SKU_LIST";
export const REQUEST_PRODUCT_SKU = "REQUEST_PRODUCT_SKU";
export const RESET = "RESET";

export const resetToInitialState = () => ({
  type: RESET
});

export const setList = (data) => {
  return {
    type: SET_PRODUCT_SKU_LIST,
    payload: data
  };
};

export const getAllSKUs = (orderId, { page, limit }) => {
  return async (dispatch) => {
    dispatch({ type: REQUEST_PRODUCT_SKU });
    try {
      const res = await API.get(`${ORDERS_URL}/${orderId}/product-skus?page=${page}&limit=${limit}`);
      dispatch(setList(res));
      return res;
    } catch (error) {
      console.error(error);
      dispatch(setError("Something went wrong!"));
      throw error;
    }
  };
};

const initialState = {
  isLoading: false,
  loaded: false,
  columns: [],
  rows: [],
  count: 0,
  order: null
};

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case RESET:
      return initialState;
    case SET_PRODUCT_SKU_LIST:
      return {
        ...state,
        isLoading: false,
        loaded: true,
        columns: payload.columns,
        rows: payload.rows,
        count: payload.count
      };
    case REQUEST_PRODUCT_SKU:
      return {
        ...state,
        isLoading: true,
        loaded: false
      };
    default:
      return state;
  }
}
